module.exports = __webpack_public_path__ + "img/airtime-call.9fcff00f.svg";